import { render, staticRenderFns } from "./GeoChart.vue?vue&type=template&id=2a9ea605&scoped=true"
import script from "./GeoChart.vue?vue&type=script&lang=js"
export * from "./GeoChart.vue?vue&type=script&lang=js"
import style0 from "./GeoChart.vue?vue&type=style&index=0&id=2a9ea605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ea605",
  null
  
)

export default component.exports